/*
 * Sticky Header Reducer
 * Maneja el estado de scroll para mostrar/ocultar search bar en header
 */

import { SET_STICKY_HEADER } from '../actions/stickyHeader';

const initialState = {
  isSticky: false
};

export default function stickyHeader(state = initialState, action) {
  switch (action.type) {
    case SET_STICKY_HEADER:
      return {
        ...state,
        isSticky: action.payload.isSticky
      };
    default:
      return state;
  }
}
